import { clsx, type ClassValue } from 'clsx'

/**
 * * Utility function to merge class names
 * * Replaces tailwind-merge with simple clsx (no conflict resolution needed)
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
